import React from 'react'
import { Link, useNavigate} from 'react-router-dom'
import { IoMdAdd, IoMdSearch} from 'react-icons/io'

const Navbar = ({searchTerm, setSearchTerm, user}) => {
  
  const navigate = useNavigate(); 

  if (!user) return null;

  return (
    <div className='flex gap-2 md:gap-5 w-full pb-7 mt-5'>
      <div className='flex justify-start items-center w-full px-2 rounded-md bg-white border-none outline-none focus-within:shadow-sm'>
        <IoMdSearch fontSize={21} className='ml' />
        <input
          type="text"
          onChange={(e) => { setSearchTerm(e.target.value) }}
          placeholder="Search"
          value={searchTerm}
          onFocus={() => navigate('/search') }
          className='w-full outline-none p-1 bg-white'
        />
      </div>
      <div className='flex gap-3'>
        <Link to={`user-profile/${user._id}`} className='hidden md:block'>
          <img src={user.image} alt="user" className='w-12 h-10 rounded-full' />
        </Link>
        <Link to={`create-pin`} className=' w-10 h-10 items-center flex justify-center text-black md:w-14 md:h-10 round'>
          <IoMdAdd fontSize={25} />
        </Link>
      </div>
    </div>
  )
}

export default Navbar